import type { QueryClient } from "@tanstack/react-query";
import { type ParsedLocation, redirect } from "@tanstack/react-router";
import { meQueryOptions } from "@/api/queries/session";
import { defaultScope } from "@/lib/store-scope";

/**
 * Old links without a store (`/opportunities/123?view=…`, bookmarks, shared URLs) open the same
 * page in this browser's default scope (`/{storeId}/…` or `/ALL/…`).
 */
export async function redirectIntoScope({ context, location }: { context: { queryClient: QueryClient }; location: ParsedLocation }): Promise<never> {
  const me = await context.queryClient.ensureQueryData(meQueryOptions());
  if (!me) throw redirect({ to: "/login", search: { redirect: location.href } });
  throw redirect({ href: `/${defaultScope(me)}${location.pathname}${location.searchStr}`, replace: true });
}
